import React from 'react';
// 遅延読み込み対応
const createPictureElement = (fileName, ext, alt, className, lazyload) => {
    if (lazyload) {
        return (React.createElement("picture", null,
            React.createElement("source", { "data-srcset": `${fileName}.webp?${_CACHEBUSTER}`, type: "image/webp" }),
            React.createElement("img", { "data-src": `${fileName}.${ext}?${_CACHEBUSTER}`, alt: alt, className: `lazyload ${className}` })));
    }
    else {
        return (React.createElement("picture", null,
            React.createElement("source", { srcSet: `${fileName}.webp?${_CACHEBUSTER}`, type: "image/webp" }),
            React.createElement("img", { src: `${fileName}.${ext}?${_CACHEBUSTER}`, alt: alt, className: className })));
    }
};
const ImgPicture = ({ fileName, ext, alt, className, lazyload }) => {
    return (React.createElement(React.Fragment, null,
        ext === 'gif' &&
            React.createElement("img", { src: `${fileName}.${ext}?${_CACHEBUSTER}`, alt: alt }),
        ext !== 'gif' &&
            createPictureElement(fileName, ext, alt, className, lazyload)));
};
ImgPicture.defaultProps = {
    ext: 'png',
    lazyload: false,
    className: ''
};
export default ImgPicture;
